import React from 'react';

import { useTypedSelector } from '@/store/store';
import { getShowMoreParams } from '@/store/reducers/cars-stock';
import {
  FiltersWrapper,
  MoreParams,
} from '@/modules/CarsStock/components/common.styles';
import AllParamsButton from '@/modules/CarsStock/components/Mobile/components/AllParamsButton';

import ElectricEnginesFilter from './components/ElectricEnginesFilter';
import BatteryTypeFilter from './components/BatteryTypeFilter';
import PowerReserveFilter from './components/PowerReserveFilter';
import GearboxFilter from './components/GearboxFilter';
import PriceFilter from './components/PriceFilter';
import YearFilter from './components/YearFilter';
import BodyFilter from './components/BodyFilter';
import WheelFilter from './components/WheelFilter';
import MileageFilter from './components/MileageFilter';
import ColorFilter from './components/ColorFilter';
import EngineTypeFilter from './components/EngineTypeFilter';
import EngineCapacityFilter from './components/EngineCapacityFilter';
import VatFilter from './components/VatFilter';
import LocationFilter from './components/LocationFilter';
import SpecialFilter from './components/SpecialFilter';
import GradeFilter from './components/GradeFilter';

export function ParamsFilterAmp() {
  const isShowMoreParams = useTypedSelector(getShowMoreParams);

  return (
    <React.Fragment>
      <FiltersWrapper>
        <EngineTypeFilter />
        <YearFilter />
        <PriceFilter />
        <VatFilter />
      </FiltersWrapper>

      <MoreParams isVisible={isShowMoreParams}>
        <FiltersWrapper>
          <GearboxFilter />
          <BodyFilter />
          <EngineCapacityFilter />
          <WheelFilter />
          <MileageFilter />
          <ColorFilter />
          <LocationFilter />
          <BatteryTypeFilter />
          <PowerReserveFilter />
          <ElectricEnginesFilter />
          <GradeFilter />
        </FiltersWrapper>
      </MoreParams>

      <AllParamsButton />

      <SpecialFilter />
    </React.Fragment>
  );
}
